import {MapStyleDark, MapStyleWhite} from "./mapStyles";
import {showBodyScroll} from "../PageHelpers";

class MapConstructor{

    type;

    mapElementId = 'map';

    map;
    markerArr = [];

    point = null;
    route = null;

    directionsService;
    render_routes = [];

    savedStorage = true;

    onUpdateRoute = null;
    onClickNext = () => {};
    onClose = () => {};

    constructor(opts){

        this.mapStyle = MapStyleDark;
        this.maxZoom = 17;
        this.autoSetMarkerAfterSearch = false;
        this.avoidHighways = false;

        if(opts){
            this.mapElementId  = opts.mapElementId || 'map';
            this.savedStorage  = opts.savedStorage || true;
            this.onUpdateRoute = opts.onUpdateRoute || null;
            if(opts.onClickNext) this.onClickNext = opts.onClickNext;
            if(opts.onClose) this.onClose = opts.onClose;
            if(opts.mapStyle) this.mapStyle = opts.mapStyle;
            if(opts.maxZoom) this.maxZoom = opts.maxZoom;
            if(opts.autoSetMarkerAfterSearch) this.autoSetMarkerAfterSearch = opts.autoSetMarkerAfterSearch;
        }

        this.mapContainer = $('<div class="mapContainer">' +
            '<button class="crossMap" type="button"><i class="icon-cross"></i></button>' +
            '<div id="map"></div>' +
            '<div class="map_search_location">' +
                '<i class="icon-location-pin2"></i>' +
                '<input type="text" class="location autocomplete" data-search="true" autocomplete="off" placeholder="Search address">' +
            '</div>' +
            '<div class="map_sidebar">' +
                '<div class="route_container">' +
                    '<div class="route-ditance">' +
                        '<span>Distance: </span>' +
                        '<span class="distance">0</span>' +
                        '<!--<button type="button" class="aiCorrect">Recomended poi</button>-->' +
                    '</div>' +
                    '<div class="route-options p_10 hide">' +
                        '<label class="flex-row gap_1 align-items-center">' +
                            '<input type="radio" name="road-preference" value="highways" checked class="road-preference">' +
                            '<span>Highways</span>' +
                        '</label>' +
                        '<label class="flex-row gap_1 align-items-center">' +
                            '<input type="radio" name="road-preference" value="avoidHighways" class="road-preference">' +
                            '<span>Avoid highway</span>' +
                        '</label>' +
                        '<label class="flex-row gap_1 align-items-center">' +
                            '<input type="radio" name="road-preference" value="windingRoads" class="road-preference">' +
                            '<span>Winding roads</span>' +
                        '</label>' +
                    '</div>' +
                    '<div class="routeList"></div>' +
                    '<div class="add-route-item">' +
                        '<div class="route-item">' +
                            '<div class="route-item--address">' +
                                '<input type="text" class="location autocomplete ui-autocomplete-input" value="" placeholder="Add new location" autocomplete="off">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="maps_sidebar--bottom">' +
                '<span class="bottomText"></span>' +
                '<button type="button" class="btn" id="next-btn">SAVE</button>' +
            '</div>' +
        '</div>');
        this.mapElement = this.mapContainer.find('#' + this.mapElementId)[0];

        this.render_routes = [];
        this.markerArr = [];

    }

    getAddressByCoordinates(lat, lng){
        return new Promise(resolve => {
            googleGeocoder(lat, lng).then(googleGeocoderResponse => {
                resolve(getAddressFromGoogleGeocoderResponse(googleGeocoderResponse));
            });
        })
    }

    getMapContainer(){
        return this.mapContainer;
    }

    initMap(){

        let self = this;

        this.map = new google.maps.Map(this.mapElement, {
            center: {lat: 42, lng: -31},
            zoom: 3,
            maxZoom: self.maxZoom,
            minZoom: 2,
            styles: self.mapStyle,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            draggableCursor: 'default',
            gestureHandling: 'greedy'
        })

        this._initActions();
    }

    _initActions(){

        let self = this;

        if(self.type === 'route'){
            self.directionsService = new google.maps.DirectionsService();
            google.maps.event.addListener(self.map, 'click', function(e){
                self.placeMarker(e.latLng);
            });
        }else{
            google.maps.event.addListener(self.map, 'click', function(e){
                if(self.point !== null) self.point.setMap(null);
                self.placePoint(e.latLng);
            });
        }

        self.mapContainer.on('click', '.crossMap', function(){
            $('.mapConstructor').removeClass('full');
            showBodyScroll();
            self.onClose();
        })

        self.mapContainer.on('click', '.aiCorrect', function(){

            let th = $(this);

            let def = th.html();

            th.html(LoaderBox.renderElement());

            let addresses = [];

            self.markerArr.forEach(m => {
                addresses.push(m.data.address);
            })

            let fm = self.markerArr.shift();
            let lm = self.markerArr.pop();

            $.get("/test/ai/recomedRoute.php", {addresses: addresses}, function(d){

                th.html(def);

                let poi = JSON.parse(d);

                let mks = [];
                mks.push(fm);
                mks.push(...self.markerArr);

                poi.forEach(p => {

                    let marker = self.createMarker(new google.maps.LatLng(p.latitude, p.longitude));
                    marker.data.text = p.poi_name + "\n" + p.poi_description;
                    mks.push(marker);

                })

                mks.push(lm);
                self.markerArr = mks;
                self.recalcMarkerIndexes();
                self.addMarkersAddresses();
                self.calculateAndDisplayRoute(true);

                console.log(self.markerArr);
            })
        })

        self.mapContainer.on('change', 'input[name="road-preference"]', function(){

            switch($(this).val()){
                case 'highways':
                    self.avoidHighways = false;
                    break;
                case 'avoidHighways':
                    self.avoidHighways = true;
                    break;
                case 'windingRoads':
                    self.true = false;
                    break;
            }


            self.calculateAndDisplayRoute(true);
        })

        self.mapContainer.on('click', '#next-btn', function(){
            self.onClickNext();
        })

        self.mapContainer.on('focus', '.location.autocomplete', function(){

            let locationAutocomplete = $(this);

            $(this).autocomplete({
                limit: 10,
                delay: 300,
                minLength: 2,
                source: function(request, response){
                    $.ajax({
                        url: "https://maps.googleapis.com/maps/api/geocode/json",
                        dataType:"json",
                        data:{address: request.term, sensor: "false", language: "en", key: "AIzaSyB0y-D7-Wh6t1lyNoBvlHJqLq1smR6Bk8I"},
                        success: function(data){
                            if(data.status === "OK"){
                                response($.map(data.results, function(item){
                                    return{
                                        label: item.formatted_address,
                                        value: item.formatted_address,
                                        location: item.geometry.location
                                    }
                                }));
                            }
                        }
                    });
                },
                select: function(event, ui){
                    if(ui.item){

                        let index = locationAutocomplete.closest('.route-item').data('index');
                        let between = locationAutocomplete.closest('.route-item').data('between');

                        self.map.setCenter(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng));
                        self.map.setZoom(22);

                        if(self.autoSetMarkerAfterSearch === true){
                            self.placeMarker(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng));
                        }

                        if(locationAutocomplete.data('search') === true){
                            return true;
                        }

                        if(between === true){
                            self.placeMarker(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng), index);
                        }else if(index){
                            locationAutocomplete.val(ui.item.value);
                            let marker = self.markerArr[index];
                            marker.data.address = ui.item.value;
                            self.changeMarkerPosition(marker, ui.item.location);
                        }else{
                            self.placeMarker(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng));
                        }

                    }
                }
            })
        })

    }

    createGoogleLatLng(lat, lng){
        return new google.maps.LatLng(lat, lng);
    }

    placePoint(googleLatLng){

        let self = this;

        self.point = new google.maps.Marker({
            data: {address: '', position: {lat: googleLatLng.lat(), lng: googleLatLng.lng()}},
            icon: window.host + '/template/img/markers/m-def.png',
            map: self.map,
            position: googleLatLng,
            draggable: true
        });
        self.map.setCenter(googleLatLng);
        self.map.setZoom(10);
        self.getAddressByCoordinates(self.point.position.lat(), self.point.position.lng()).then(address => {
            self.point.data.address = address;
        });
        self.point.addListener('dragend', function(e){
            self.map.setCenter(e.latLng);
            self.getAddressByCoordinates(this.position.lat(), this.position.lng()).then(address => {
                this.data.address = address;
            });
        });
    }

    placeMarker(position, index){

        let self = this;

        let marker = self.createMarker(position);
        self.getAddressByCoordinates(marker.position.lat(), marker.position.lng()).then(address => {
            marker.data.address = address;
        });
        self.insertMarker(marker, index);
        self.calculateAndDisplayRoute(true).then(() => {
            self.saveRouteToLocalStorage();
        }).catch(() => {
            self.deleteMarker(marker);
            self.calculateAndDisplayRoute(true);
        });

        return marker;

    }

    setTypeMap(type){
        this.type = type;
    }

    updateRoute(routeOnMap){
        this.route = routeOnMap;
        this.onUpdateRoutePath();
    }

    setMarkerType(marker, type){

        marker.data.type = type;
        marker.setIcon(routePointTypes.get(type).icon);
        type === 'point' ? this.setMarkerLabel(marker) : this.removeMarkerLabel(marker);
    }

    getSelectorPointType(marker){

        let ret = '';
        let overlay = routePointTypes.get(marker.data.type).change === false ? '<div class="point_type--overlay"><span>This is the final destination for the current route. You can\'t change this icon.</span></div>' : ''

        routePointTypes.forEach(function(item, key){
            if(item.change === true){
                let checked = marker.data.type === key ? 'checked' : '';
                ret += '<div class="point_type--item"><input '+checked+' type="radio" name="point_type" value="'+key+'" id="point_'+key+'"><label for="point_'+key+'"><img alt src="'+item.icon+'"></label></div>';
            }
        })

        return $('<div class="point_type">' + overlay + ret + '</div>');

    }



    renderDialogForEditMarker(marker){

        let self = this;

        let date = '';
        let text = '';

        if(marker.data.date && marker.data.date !== 'null') date = showDate('M d Y, h:i a', marker.data.date);
        if(marker.data.text && marker.data.text !== 'null') text = marker.data.text;

        let content = $('<div><div class="form-item point_edit_address">'+marker.data.address+'</div><div class="form-item">' +
            '<div class="form-item__label">Date/Time</div>' +
            '<div class="form-item__control"><input type="text" name="point_date" class="point_date datePick" placeholder="Time (optional)" value="' + date + '"></div></div></div>');
        content.append('<div class="form-item">' +
            '<div class="form-item__label">Description point</div>' +
            '<div class="form-item__control"><textarea class="point_text autosize" placeholder="Description (optional)">'+text+'</textarea></div></div>');
        content.append(self.getSelectorPointType(marker));

        $.confirm({
            title: 'Route Point',
            content: content,
            boxWidth: 400,
            onContentReady: function(){
                window.updateDatepicker();
            },
            buttons: {
                delete: {
                    btnClass: 'red',
                    action: function(){
                        if(self.markerArr.length >= 2 && self.markerArr[0] === marker){
                            self.getAddressByCoordinates(self.markerArr[1].position.lat(), self.markerArr[1].position.lng()).then(address => {
                                self.markerArr[1].data.address = address;
                            });
                            // TODO: кроме получения адреса точки, нужно обновить данные в ивенте, которые предзаполняются в блоке локация
                            // Это было сделано в функции geocoderAddress - /ajax/getLocationEntity
                        }
                        self.deleteMarker(marker);
                        self.saveRouteToLocalStorage();
                        self.renderRouteListElements()
                        renderRouteSteps(self.getRoutePoints(), true);
                        self.onUpdateRoutePath();
                        self.calculateAndDisplayRoute(true);
                    }
                },
                ok: {
                    btnClass: 'green',
                    action: function(){
                        let icon = content.find('input[name=point_type]:checked');
                        let new_date = content.find('input.point_date').val().trim();
                        if(new_date !== null && new_date.length > 0){
                            marker.data.date = new Date(new_date).getTime()/1000;
                        }

                        let text = content.find('.point_text').val().trim();
                        if(text.length > 0){
                            marker.data.text = text;
                        }

                        if(icon.length === 1){
                            self.setMarkerType(marker, icon.val());
                        }

                        self.saveRouteToLocalStorage();
                        self.renderRouteListElements();
                        renderRouteSteps(self.getRoutePoints(), true);
                        self.onUpdateRoutePath();
                    }
                }
            }
        });

    }

    markerEvents(marker){

        let self = this;

        let lastPosition;
        marker.addListener('dragstart', function(){
            lastPosition = this.position;
        })
        marker.addListener('dragend', function(){
            self.getAddressByCoordinates(this.position.lat(), this.position.lng()).then(address => {
                this.data.address = address;
            });
            self.calculateAndDisplayRoute(true).then(() => {
                self.saveRouteToLocalStorage();
            }).catch(() => {
                self.changeMarkerPosition(marker, lastPosition);
            });
        });
        marker.addListener('click', function(){
            self.renderDialogForEditMarker(this);
        });
    }

    showRoute(json_points){

        let self = this;
        let points;

        if(typeof json_points === 'object'){
            points = json_points;
        }else{
            points = JSON.parse(json_points);
        }

        if(points.length > 0){
            points.forEach(function(item){
                let marker = new google.maps.Marker({
                    data: item,
                    map: self.map,
                    position: item.position,
                    draggable: true
                });
                self.setMarkerType(marker, marker.data.type);
                self.markerEvents(marker);
                self.insertMarker(marker);
            });
            self.calculateAndDisplayRoute(false);
        }
    }

    getRoutePoints(){

        let self = this;

        let routePoints = [];
        if(self.markerArr.length > 0){
            self.markerArr.forEach(function(marker){
                marker.data.position = marker.position;
                routePoints.push(marker.data);
            });
        }
        return routePoints;
    }

    resetStorage(){
        window.localStorage.removeItem('route');
    }

    saveRouteToLocalStorage(){

        let self = this;

        if(self.savedStorage === false) return;

        window.localStorage.setItem('route', JSON.stringify(self.getRoutePoints()));

    }

    createMarker(position){

        let self = this;

        let marker = new google.maps.Marker({
            data:{
                type:       'point',
                address:    null,
                date:       null,
                text:       null,
                index:      null,
                position:   {lat: position.lat(), lng: position.lng()}
            },
            map: self.map,
            position: position,
            draggable: true
        });
        self.markerEvents(marker);

        return marker;
    }

    deleteMarker(marker){

        let self = this;

        self.markerArr.forEach(function(item, key){
            if(item === marker){
                self.markerArr.splice(key, 1);
                marker.setMap(null);
            }
        })
    }

    insertMarker(marker, index){

        let self = this;

        if(index !== undefined){
            self.markerArr.splice(index, 0, marker);
        }else{
            self.markerArr.push(marker);
        }

    }



    changeMarkerPosition(marker, position){

        let self = this;

        marker.setPosition(position);
        self.calculateAndDisplayRoute(true);
        self.saveRouteToLocalStorage();

    }

    /** Корректировка позиции маркеров для их расположения на маршруте а не в лесу */
    setActualyMarkersPosition(route){

        let self = this;

        /*for(let p = 0; p < route.legs.length; p++){
            self.markerArr[p].setPosition(route.legs[p].start_location);
        }*/

        route.legs.forEach((leg, key) => {
            self.markerArr[key].setPosition(leg.start_location);
        })

        self.markerArr[self.markerArr.length-1].setPosition(route.legs[route.legs.length - 1].end_location);

        self.saveRouteToLocalStorage();

    }

    setMarkerLabel(marker){

        let self = this;

        marker.setLabel({
            text: marker.data.index.toString(),
            className: 'waypoints--label',
            color: 'white'
        });
    }

    removeMarkerLabel(marker){

        let self = this;
        marker.setLabel(null);

    }

    /**
     * Добавит адреса для маркеров, для которых еще нет адресов
     */
    addMarkersAddresses(){
        let self = this;

        for(let i = 0; i < self.markerArr.length - 1; i++){
            const marker = self.markerArr[i];
            marker.data.index = i;

            if(!marker.data.address){
                self.getAddressByCoordinates(marker.position.lat(), marker.position.lng()).then(address => {
                    marker.data.address = address;
                });
            }

        }

    }

    /**
     * Переназначит индексы */
    recalcMarkerIndexes(){

        let self = this;

        let markerStart = self.markerArr[0];
        markerStart.data.index = 0;
        self.setMarkerType(markerStart, 'start');

        if(self.markerArr.length > 1){
            let markerEnd = self.markerArr[self.markerArr.length - 1];
            markerEnd.data.index = self.markerArr.length - 1;
            self.setMarkerType(markerEnd, 'finish');

            for(let i = 1; i < self.markerArr.length - 1; i++){
                const marker = self.markerArr[i];
                marker.data.index = i;
                if(
                    marker.data.type === 'point' ||
                    marker.data.type === 'finish'
                ){
                    self.setMarkerType(marker, 'point');
                    self.setMarkerLabel(marker);
                }
            }
        }

    }

    getWaypoints(){

        let self = this;

        let waypoints = [];

        if(self.markerArr.length < 2) return waypoints;

        for(let i = 1; i < self.markerArr.length - 1; i++){
            const marker = self.markerArr[i];
            waypoints.push({
                location: marker.position,
                stopover: true
            });
        }

        return waypoints;

    }

    /**
     * @param {boolean} preserveViewport - false, если нужно отключить масштабирование после измнения маршрута
     */
    calculateAndDisplayRoute(preserveViewport){

        let self = this;

        if(self.markerArr.length === 0){
            self.updateRoute(null);
            return;
        }

        if(self.render_routes.length > 0){
            self.render_routes.forEach(function(item){
                item.setMap(null);
            })
        }

        self.recalcMarkerIndexes();
        let waypoints   = self.getWaypoints();
        let markerStart = self.markerArr[0];

        let markerEnd   = self.markerArr[self.markerArr.length - 1];

        console.log(waypoints);

        const DirectionsRoute = {
            origin: new google.maps.LatLng(markerStart.position.lat(), markerStart.position.lng()),
            destination: new google.maps.LatLng(markerEnd.position.lat(), markerEnd.position.lng()),
            waypoints: waypoints,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
            avoidTolls: true,
            avoidHighways: self.avoidHighways
        }

        return self.sendToDirectionServices(DirectionsRoute, preserveViewport);

    }
    /**
     * @param {object} DirectionsRoute
     * @param {boolean} preserveViewport - false, если нужно отключить масштабирование после измнения маршрута
     */
    sendToDirectionServices(DirectionsRoute, preserveViewport){

        let self = this;

        return new Promise((resolve, reject) => {

            self.directionsService.route(DirectionsRoute, (response, status) => {

                    if(status === "OK"){

                        let DirectionRenderer = new google.maps.DirectionsRenderer({
                            map: self.map,
                            suppressMarkers: true,
                            suppressInfoWindows: false,
                            draggable: true,
                            preserveViewport: preserveViewport,
                            polylineOptions: {
                                strokeColor: '#1aa7ec',
                                strokeWeight: 4
                            }
                        });

                        DirectionRenderer.setDirections(response);

                        /*=== Гугл мог отсортировать промежуточные точки поэтому корректируем их чтобы описания совпадали ===*/
                        let fm = self.markerArr.shift();
                        let lm = self.markerArr.pop();

                        let points = [fm];

                        DirectionRenderer.getDirections().routes[0].waypoint_order.forEach((oldIndex, newIndex) => {
                            let m = self.markerArr[oldIndex];
                            points.push(m);
                        })

                        if(lm) points.push(lm);

                        self.markerArr = points;

                        self.recalcMarkerIndexes();
                        /*==============================================*/

                        self.setActualyMarkersPosition(DirectionRenderer.getDirections().routes[0]);

                        google.maps.event.addListener(DirectionRenderer, "directions_changed", function(){
                            let wp = DirectionRenderer.getDirections().request.waypoints;

                            for(let w = 0; w < wp.length; w++){

                                if(
                                    self.markerArr[w+1].getPosition().lat() !== wp[w].location.lat() &&
                                    self.markerArr[w+1].getPosition().lng() !== wp[w].location.lng()
                                ){

                                    let marker = self.createMarker(wp[w].location);
                                    self.insertMarker(marker, w+1);

                                    self.getAddressByCoordinates(marker.position.lat(), marker.position.lng()).then(res => {
                                        marker.data.address = res;
                                        self.renderRouteList(DirectionRenderer.getDirections().routes[0]);
                                        self.saveRouteToLocalStorage();
                                    });

                                }

                                self.setActualyMarkersPosition(DirectionRenderer.getDirections().routes[0]);
                                self.recalcMarkerIndexes();
                                self.renderRouteList(DirectionRenderer.getDirections().routes[0]);

                                self.updateRoute(DirectionRenderer.getDirections().routes[0]);
                            }

                        });

                        self.renderRouteList(DirectionRenderer.getDirections().routes[0]);
                        self.render_routes.push(DirectionRenderer);
                        self.updateRoute(DirectionRenderer.getDirections().routes[0]);

                        resolve();

                    }else if(status === "ZERO_RESULTS"){
                        if(self.markerArr.length < 2) resolve();
                        reject();
                    }else if(status === "MAX_WAYPOINTS_EXCEEDED"){
                        reject();
                    }else{
                        reject();
                    }
                }
            )

        })

    }

    renderRouteList(route){

        let self = this;

        let distance = self.getRouteDistance(route);

        this.mapContainer.find('.route_container .distance').html(Number.parseFloat(distance/1000).toFixed(1) + ' km.');

        self.renderRouteListElements();

    }

    getRoutePath(){
        return this.route ? this.route.overview_path : null;
    }

    getRouteDistance(route){

        if(!route){
            route = this.route;
        }

        let distance = 0;

        if(route && route.legs.length > 0){
            route.legs.forEach(leg => {
                distance += leg.distance.value;
            })
        }

        return distance;

    }

    onUpdateRoutePath(){

        let self = this;

        if(self.onUpdateRoute){
            self.onUpdateRoute(self);
        }

    }

    renderRouteElement(marker, index){

        let self = this;

        let li = $('<li><div class="route-item" data-index="' + index + '"><div class="route-item--icon setting"><img src="' + routePointTypes.get(marker.data.type).icon + '" alt></div><div class="route-item--address"><input type="text" class="location autocomplete" value="" placeholder="' + marker.data.address + '"></div><div class="route-item--action setting"><i class="icon-edit"></i></div><div class="route-item--add_after"><i class="icon-plus2"></i></div></li>');

        let edit = li.find('.setting');
        edit.on('click', function(){
            self.map.setCenter(self.markerArr[index].getPosition());
            self.renderDialogForEditMarker(self.markerArr[index]);
        })

        let addItem = li.find('.route-item--add_after');
        addItem.on('click', function(){
            $(this).css('display', 'none');
            let newItem = $('<li class="add-route-item"><div class="route-item" data-index="' + (index + 1) + '" data-between="true"><div class="route-item--address"><input type="text" class="location autocomplete ui-autocomplete-input" value="" placeholder="Add new location" autocomplete="off"></div><div class="route-item--action"><i class="icon-cross"></i></div></div></li>');
            li.after(newItem);

            newItem.find('.icon-cross').on('click', () => {
                newItem.remove();
                addItem.css('display', 'flex');
            })

            newItem.find('input').focus();
        })

        return li;

    }

    renderRouteListElements(){

        let self = this;

        let route = $('<ul class="route"></ul>');

        for(let i = 0; i < self.markerArr.length; i++){
            let marker = self.markerArr[i];
            let li = self.renderRouteElement(marker, i);
            route.append(li);

            if(marker.data.type === 'point'){
                li.find('.route-item--icon.setting').prepend($('<span class="route-item--label">' + i + '</span>'));
            }
        }

        self.mapContainer.find('.add-route-item input.location').val('');
        self.mapContainer.find('.routeList').html(route);

    }

    showFullMap(){

        let self = this;

        self.mapContainer.addClass(self.type+'Type');

        self.showZoomControl();

    }

    aligment(){

        let self = this;
        if(self.route){
            self.map.fitBounds(self.route.bounds);
        }else if(self.point){
            self.map.setCenter(self.point.getPosition());
            self.map.setZoom(9);
        }
    }

    showZoomControl(){
        this.map.setOptions({zoomControl:true});
    }

    hideZoomControl(){
        this.map.setOptions({zoomControl:false});
    }

    setBottomText(bottomText) {
        this.mapContainer.find('.bottomText').html(bottomText);
    }
}

export default MapConstructor;